// Single app - uses demo's Supabase directly
export const APPS = {
  demo: {
    id: 'demo',
    name: 'Demo',
    supabaseUrl: 'https://lbazotqhqiozgdpforfl.supabase.co',
    supabaseKey: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImxiYXpvdHFocWlvemdkcGZvcmZsIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjU0OTM0NTMsImV4cCI6MjA4MTA2OTQ1M30.nMLQ19z3NhhEGQCSMPm_P4A9P6wY64ZeFPCkGGMtuY4',
  },
}

export const DEFAULT_APP = 'demo'
